import { useState } from "react"
import { Link } from "react-router-dom"

const CTASection = () => {
  return (
    <section className="py-16 bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold mb-6">Ready to Create Something Amazing?</h2>
        <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
          Encourage visitors to browse the shop or place a custom order. Let's bring your vision to life!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Link to="/shop" className="text-xl font-bold text-gray-900 italic">
          <button className="bg-white text-black px-8 py-3 font-medium hover:bg-gray-100 transition-colors">
            Browse Shop
          </button>
          </Link>

        </div>
      </div>
    </section>
  )
}

export default CTASection
